import { render, staticRenderFns } from "./updateContactDetailsModal.vue?vue&type=template&id=2015907e&scoped=true"
import script from "./updateContactDetailsModal.vue?vue&type=script&lang=js"
export * from "./updateContactDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./updateContactDetailsModal.vue?vue&type=style&index=0&id=2015907e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015907e",
  null
  
)

export default component.exports